export enum MoveStageTypes {
	INBOUND = 'INBOUND',
	LOADING = 'LOADING',
	EMPTY_RETURN = 'EMPTY_RETURN',
	OFFLOADING = 'OFFLOADING',
	BORDER = 'BORDER',
	FUELLING = 'FUELLING',
}
